
<div class="v-flex">
    <!-- Filter menu -->
    <crm-entry-filter-menu
        @filter = "onFilter"
    />
    <!-- Filter menu -->

    <!-- Dropdown to create new entries -->
    <v-btn
        color  = "white"
        class  = "menu-button primary--text ml-1"
        @click = "onEdit"
        dark
        depressed
    >
        <span>{{ $t('crm.title') }}</span>
        <i class="fas fa-caret-down ml-1" :class="{'menu-open':menu}"></i>
    </v-btn>
    <!-- Dropdown to create new entries -->

    <v-scale-transition>
        <v-card
            v-if      = "menu"
            elevation = "0"
            class     = "crm-edit-container pa-0 mt-2"
        >
            <div style="height: 630px; background-color: white">
                <v-tabs
                    v-model = "tabs"
                    class   = "crm-tabs"
                    left
                >
                    <v-tab class="crm-tab">
                        <v-icon>fas fa-phone</v-icon>
                    </v-tab>
                    <v-tab class="crm-tab">
                        <v-icon>far fa-comment</v-icon>
                    </v-tab>
                    <v-tab class="crm-tab">
                        <v-icon>far fa-bell</v-icon>
                    </v-tab>
                    <div class="crm-card-filler"></div>
                </v-tabs>

                <v-tabs-items v-model="tabs">
                    <v-tab-item>
                        <crm-entry-tab-item
                            :incident  = "incident"
                            :entry     = "createEntry(type.phone)"
                            ref        = "crmtab"
                            @saved     = "onSaved"
                            @cancel    = "onCancel"
                        />
                    </v-tab-item>

                    <v-tab-item>
                        <crm-entry-tab-item
                            :incident  = "incident"
                            :entry     = "createEntry(type.notice)"
                            ref        = "crmtab"
                            @saved     = "onSaved"
                            @cancel    = "onCancel"
                        />
                    </v-tab-item>

                    <v-tab-item>
                        <crm-entry-tab-item
                            :incident  = "incident"
                            :entry     = "createEntry(type.reminder)"
                            ref        = "crmtab"
                            @saved     = "onSaved"
                            @cancel    = "onCancel"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </v-card>
    </v-scale-transition>
</div>
